import { render } from "./Home.vue?vue&type=template&id=97112bc2&scoped=true&bindings={}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-97112bc2"

export default script